import React, { useEffect } from "react";
import "./css/About.css";

export default function About() {
  useEffect(() => {
    document.title = "About | My MLM Website";
  }, []);
  return (
    <div className="about-container">
      <h1 className="about-heading">About Us</h1>

      <p className="about-description">
        हमारी कंपनी MLM (Multi Level Marketing) solutions और software
        development services provide करती है। हम लोगों को business grow करने में
        help करते हैं और उन्हें proper tools, training और guidance provide करते
        हैं।
      </p>

      <div className="about-grid">
        <div className="about-card">
          <h3>Our Mission</h3>
          <p>
            लोगों को digital MLM platform provide करना जिससे वो अपने network को
            expand कर सकें और बेहतर earning opportunities पा सकें।
          </p>
        </div>

        <div className="about-card">
          <h3>Our Vision</h3>
          <p>
            भारत और विश्व स्तर पर सबसे विश्वसनीय और advanced MLM software
            company बनना और हर एक individual को empower करना।
          </p>
        </div>

        <div className="about-card">
          <h3>Why Choose Us</h3>
          <p>
            - 24/7 Support
            <br />- Secure & Fast Software
            <br />- Affordable Pricing
            <br />- Experienced Team
          </p>
        </div>
      </div>
    </div>
  );
}
